import SEO from "@/components/feature/SEO";
import Navbar from "@/components/base/Navbar";
import Footer from "@/components/base/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedArticles from "./components/FeaturedArticles";
import HomeFAQ from "./components/HomeFAQ";
import CTASection from "./components/CTASection";

export default function Home() {
  const pageTitle = `jm下载 - 官方安全下载指南`;
  const pageDescription = `本页专注于jm下载的完整指南，提供最新版本的jm下载方法、步骤详解及常见问题解答，帮助用户快速、安全地完成jm下载，解决下载失败、速度慢等常见问题，是您jm下载的权威参考页面。`;
  const pageKeywords = `jm下载,jm下载最新版,jm官方下载,jm下载安装教程,jm下载失败怎么办,jm下载地址,jm安全下载`;
  const canonicalUrl = `https://www.jmxiazai.com`;

  const seoMeta = {
    title: pageTitle,
    description: pageDescription,
    keywords: pageKeywords,
    canonical: canonicalUrl,
    ogTitle: pageTitle,
    ogDescription: pageDescription,
    ogUrl: canonicalUrl,
    ogType: "website",
    ogLocale: "zh_CN",
    twitterCard: "summary_large_image",
    twitterTitle: pageTitle,
    twitterDescription: pageDescription,
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "jm下载指南",
        url: canonicalUrl,
        description: pageDescription,
        potentialAction: {
          "@type": "SearchAction",
          target: `${canonicalUrl}/search?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "jm下载指南",
        url: canonicalUrl,
        description: pageDescription,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: pageTitle,
        description: pageDescription,
        url: canonicalUrl,
      },
    ],
  };

  return (
    <>
      <SEO meta={seoMeta} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <HomeFAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}